import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    allLangs: [],
};

const LanguagesSlice = createSlice({
  name: "language",
  initialState: initialState,
  reducers: {
    setAllLangs(state, action) {
        const { addedLanguages } = action.payload;
        const mergedLanguages = [
          {
            label: "English",
            value: "en",
          },
          ...addedLanguages,
        ];
        state.allLangs  = mergedLanguages;
      }
    }
});
export const {
    setAllLangs
} = LanguagesSlice.actions;
export default LanguagesSlice.reducer;